import clsx from 'clsx';
import React from 'react';
import PropTypes from 'prop-types';
import elementType from 'prop-types-extra/lib/elementType';
import { bsClass, bsSizes, bsStyles, getClassSet, prefix, splitBsProps } from './utils/bootstrapUtils';
import { Size, State, Style } from './utils/StyleConfig';
import SafeAnchor from './SafeAnchor';
import { jsx as _jsx } from "react/jsx-runtime";
class Button extends React.Component {
  renderAnchor(elementProps, className) {
    return /*#__PURE__*/_jsx(SafeAnchor, {
      ...elementProps,
      className: clsx(className, elementProps.disabled && 'disabled')
    });
  }
  renderButton(_ref, className) {
    let {
      componentClass,
      ...elementProps
    } = _ref;
    const Component = componentClass || 'button';
    return /*#__PURE__*/_jsx(Component, {
      ...elementProps,
      type: elementProps.type || 'button',
      className: className
    });
  }
  render() {
    const {
      active,
      block,
      className,
      ...props
    } = this.props;
    const [bsProps, elementProps] = splitBsProps(props);
    const classes = {
      ...getClassSet(bsProps),
      active,
      [prefix(bsProps, 'block')]: block
    };
    const fullClassName = clsx(className, classes);
    if (elementProps.href) {
      return this.renderAnchor(elementProps, fullClassName);
    }
    return this.renderButton(elementProps, fullClassName);
  }
}
Button.defaultProps = {
  active: false,
  block: false,
  disabled: false
};
export default bsClass('btn', bsSizes([Size.LARGE, Size.SMALL, Size.XSMALL], bsStyles([...Object.values(State), Style.DEFAULT, Style.PRIMARY, Style.LINK], Style.DEFAULT, Button)));